import { render, staticRenderFns } from "./DepartmentChooser.vue?vue&type=template&id=2dade6c5&"
import script from "./DepartmentChooser.vue?vue&type=script&lang=js&"
export * from "./DepartmentChooser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports